<script setup>
import {defineProps, toRefs, computed, ref} from "vue";

const props = defineProps({
  data: {},
});
const {data} = toRefs(props);

</script>

<template>
	<div>
    {{ data.value }}
	</div>
</template>

<style lang="scss" scoped>

</style>